export const FacebookLogo: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300" {...props}>
    <title>Facebook Logo</title>
    <path
      d="M300 150C300 67.158 232.842 0 150 0C67.158 0 0 67.158 0 150C0 220.344 48.432 279.372 113.766 295.584V195.84H82.836V150H113.766V130.248C113.766 79.194 136.872 55.53 186.996 55.53C196.5 55.53 212.898 57.396 219.606 59.256V100.806C216.066 100.434 209.916 100.248 202.278 100.248C177.684 100.248 168.18 109.566 168.18 133.788V150H217.176L208.758 195.84H168.18V298.902C242.454 289.932 300.006 226.692 300.006 150H300Z"
      fill="#0866FF"
    />
    <path
      d="M208.752 195.84L217.17 150H168.174V133.788C168.174 109.566 177.678 100.248 202.272 100.248C209.91 100.248 216.06 100.434 219.6 100.806V59.256C212.892 57.39 196.494 55.53 186.99 55.53C136.866 55.53 113.76 79.194 113.76 130.248V150H82.8301V195.84H113.76V295.584C125.364 298.464 137.502 300 149.994 300C156.144 300 162.21 299.622 168.168 298.902V195.84H208.746H208.752Z"
      fill="white"
    />
  </svg>
);
